import axios from '@/axios';
import { normalizeForBackend } from '@/utils/normalizeData';

const artists = {
    state: () => ({
        artists: [],
        artistsRoles: []
    }),
    actions: {
        fetchAllArtists({commit}){
            return new Promise( (resolve, reject) => {
                axios.get('/artists').then(response => {
                    commit('replaceArtists', response.data)
                    resolve(response)
                }).catch(e => reject(e))
            })
        },

        fetchArtist({commit}, artistUUID){
            if (artistUUID == null || artistUUID === '' || String(artistUUID) === 'undefined' || String(artistUUID) === 'null') {
                return Promise.reject(new Error('Artist UUID is missing'));
            }
            return new Promise( (resolve, reject) => {
                axios.get(`/artist/${artistUUID}`).then(response => {
                    commit('addArtist', response.data)
                    resolve(response)
                }).catch(e => reject(e))
            })
        },

        fetchArtistsRoles({commit}){
            return new Promise((resolve,reject) => {
                axios.get('/artist-roles').then(response => {
                    commit('replaceArtistsRoles',Object.keys(response.data))
                    resolve(response)
                }).catch(error => reject(error))
            })
        },

        updateArtist({commit}, {uuid, name, spotify_id, apple_id, description}){
            if (uuid == null || uuid === '' || String(uuid) === 'undefined' || String(uuid) === 'null') {
                return Promise.reject(new Error('Artist UUID is missing'));
            }
            return new Promise((resolve, reject) => {
                axios.patch(`/artist/${uuid}`, normalizeForBackend({
                    name,
                    spotify_id,
                    spotifyId: spotify_id,
                    apple_id,
                    appleId: apple_id,
                    description
                })).then(response => {
                    commit('updateArtist',{uuid, name, spotify_id, apple_id, description})
                    resolve(response)
                }).catch(error => reject(error))
            })
        }
    },
    mutations: {
        addArtist(state, artist){
            state.artists.push(artist);
        },

        replaceArtists(state, artists){
            state.artists = artists
        },

        replaceArtistsRoles(state, artistRoles){
            state.artistRoles = artistRoles
        },

        updateArtist(state){
            console.log(state)
        }
    },
    getters: {
        getArtist: state => uuid => state.artists.find(artist => artist.uuid == uuid),

        getArtistsRoles: state => state.artistRoles
    },
};

export default artists;
